var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrizeDraws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 1.33333C5.79119 1.33333 4.00033 3.12419 4.00033 5.33333C4.00033 7.54247 5.79119 9.33333 8.00033 9.33333C10.2095 9.33333 12.0003 7.54247 12.0003 5.33333C12.0003 3.12419 10.2095 1.33333 8.00033 1.33333ZM2.66699 5.33333C2.66699 2.38781 5.05481 0 8.00033 0C10.9458 0 13.3337 2.38781 13.3337 5.33333C13.3337 8.27885 10.9458 10.6667 8.00033 10.6667C5.05481 10.6667 2.66699 8.27885 2.66699 5.33333Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.439 8.59254C10.804 8.54411 11.1391 8.80074 11.1876 9.16573L11.9942 15.2457C12.0279 15.4995 11.9133 15.7501 11.6993 15.8906C11.4854 16.0312 11.2099 16.0368 10.9904 15.9051L8.00002 14.1109L5.00968 15.9051C4.79016 16.0368 4.51462 16.0312 4.30066 15.8906C4.0867 15.7501 3.97211 15.4994 4.00582 15.2456L4.81249 9.1723C4.86096 8.80732 5.19614 8.55074 5.56113 8.59922C5.92611 8.64769 6.18269 8.98287 6.13421 9.34786L5.50965 14.0502L7.65702 12.7618C7.86814 12.6351 8.13189 12.6351 8.34301 12.7618L10.4906 14.0503L9.86581 9.34109C9.81738 8.9761 10.074 8.64096 10.439 8.59254Z",
    fill: "#16192C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeDraws);
export default __webpack_public_path__ + "static/media/prize-draws.7d650370c7841b92a688863bad815924.svg";
export { ForwardRef as ReactComponent };